export default __webpack_public_path__ + "static/cto-logo-55277dff28c39c77dcc88a7dc0cd3f0a.png";